import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { PlaceEditorPageListComponent } from '../place-editor-page-list/place-editor-page-list.component';
import { PlaceEditorPageFieldsComponent } from '../place-editor-page-fields/place-editor-page-fields.component';
import { NotifierV2Service } from 'src/app/services/notifier-v2.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-place-editor-page',
    templateUrl: './place-editor-page.component.html',
    styleUrls: ['./place-editor-page.component.scss'],
    standalone: false
})
export class PlaceEditorPageComponent implements OnInit {
  @ViewChild('placeListRef') placeListRef: PlaceEditorPageListComponent;
  @ViewChildren(PlaceEditorPageFieldsComponent) editors: QueryList<PlaceEditorPageFieldsComponent>;


  data = {
    reference: {
      Id: 0,
      rawData: "",

    },
    response: null,
    editPlaceId: 0

  };
  private sub: Subscription;

  highlightedPlaceId: number;

  constructor(private notifierService: NotifierV2Service) { }

  ngOnInit(): void {

    this.sub = this.notifierService.placeChanged$.subscribe(placeId => {
      this.data.reference.Id = placeId;
      this.reloadEditor(placeId);
    });
    const state = history.state as { placeId?: number };
    if (state?.placeId) {
      this.data.reference.Id = state.placeId;
      this.highlightedPlaceId = null;

      setTimeout(() => {
        this.highlightedPlaceId = state.placeId;
      }, 0);
    }
  }

  onPlaceListCompleted(eventData: any) {
    if (eventData) {
      this.data = {
        ...this.data,
        reference: {
          Id: eventData.id,
          rawData: eventData.rawData
        },
      };
    } else {
      //Clear the editor when a place is deleted
      this.data = {
        ...this.data,
        reference: {
          Id: 0,
          rawData: ""
        },
        editPlaceId: 0,
        response: null
      };
      this.highlightedPlaceId = 0; // Also clear selection in list
      setTimeout(() => {
        const editor = this.editors.first;
        if (editor) {
          editor.resetForm();
        }
      });
    }
  }

  onPlaceEditorCompleted(eventData: any) {
    if (eventData?.id) {
      this.data.reference = {
        Id: eventData.id,
        rawData: eventData.rawData ?? ''
      };
      this.highlightedPlaceId = null;

      setTimeout(() => {
        this.highlightedPlaceId = eventData.id;
      }, 0);
    }

    this.data.editPlaceId = 0;

    this.placeListRef.getPlaceList();
  }

  onPlaceEditCancelled() {
    this.highlightedPlaceId = null;
    // Ensure a change is detected 
    setTimeout(() => {
      this.highlightedPlaceId = 0;
    }, 0);
  }

  private reloadEditor(placeId: number) {
    const newEvent = {
      reference: {
        Id: placeId,
        rawData: "",
      }
    };

    if (placeId) {
      this.data = { ...this.data, ...newEvent };
      this.highlightedPlaceId = null;

      setTimeout(() => {
        this.highlightedPlaceId = placeId;
      }, 0);
    }
  }
}
